import React from "react";
import { Col, Row } from "react-bootstrap";

const hasValue = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

const linkWrapStyle = {
  margin: 0,
  maxWidth: "100%",
  overflowWrap: "anywhere",
  wordBreak: "break-word",
};

const ExternalLink = ({ value }) => {
  if (!hasValue(value)) {
    return "N/A";
  }
  const href = /^https?:\/\//i.test(value) ? value : `https://${value}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-block",
        maxWidth: "100%",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
      }}
    >
      {value}
    </a>
  );
};

export function hasClaimCafeProfileData(claim) {
  if (!claim) return false;
  return (
    hasValue(claim.description) ||
    hasValue(claim.website) ||
    hasValue(claim.facebook) ||
    hasValue(claim.instagram) ||
    hasValue(claim.tikTok) ||
    hasValue(claim.image) ||
    hasValue(claim.logo)
  );
}

function ClaimSubmittedCafeProfile({
  claim,
  styles,
  viewformStyle,
  empdivId = "empdiv",
}) {
  if (!hasClaimCafeProfileData(claim)) {
    return null;
  }

  return (
    <>
      <h6 style={{ color: "#666", marginTop: "20px", marginBottom: "15px" }}>
        Cafe profile (submitted by vendor)
      </h6>
      {hasValue(claim.description) && (
        <Row>
          <Col lg={12} style={{ minWidth: 0 }}>
            <div className={styles[viewformStyle]} id={empdivId}>
              <span className={styles.title}>Description</span>
              <p className={styles.empname} style={linkWrapStyle}>
                {claim.description}
              </p>
            </div>
          </Col>
        </Row>
      )}
      {(hasValue(claim.website) ||
        hasValue(claim.facebook) ||
        hasValue(claim.instagram) ||
        hasValue(claim.tikTok)) && (
        <>
          <Row>
            {hasValue(claim.website) && (
              <Col lg={4} style={{ minWidth: 0 }}>
                <div className={styles[viewformStyle]} id={empdivId}>
                  <span className={styles.title}>Website</span>
                  <p className={styles.empname} style={linkWrapStyle}>
                    <ExternalLink value={claim.website} />
                  </p>
                </div>
              </Col>
            )}
            {hasValue(claim.facebook) && (
              <Col lg={4} style={{ minWidth: 0 }}>
                <div className={styles[viewformStyle]} id={empdivId}>
                  <span className={styles.title}>Facebook</span>
                  <p className={styles.empname} style={linkWrapStyle}>
                    <ExternalLink value={claim.facebook} />
                  </p>
                </div>
              </Col>
            )}
            {hasValue(claim.instagram) && (
              <Col lg={4} style={{ minWidth: 0 }}>
                <div className={styles[viewformStyle]} id={empdivId}>
                  <span className={styles.title}>Instagram</span>
                  <p className={styles.empname} style={linkWrapStyle}>
                    <ExternalLink value={claim.instagram} />
                  </p>
                </div>
              </Col>
            )}
          </Row>
          {hasValue(claim.tikTok) && (
            <Row>
              <Col lg={4} style={{ minWidth: 0 }}>
                <div className={styles[viewformStyle]} id={empdivId}>
                  <span className={styles.title}>TikTok</span>
                  <p className={styles.empname} style={linkWrapStyle}>
                    <ExternalLink value={claim.tikTok} />
                  </p>
                </div>
              </Col>
            </Row>
          )}
        </>
      )}
      {(hasValue(claim.image) || hasValue(claim.logo)) && (
        <Row>
          {hasValue(claim.image) && (
            <Col lg={6}>
              <div className={styles[viewformStyle]} id={empdivId}>
                <span className={styles.title}>Cover image</span>
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={claim.image}
                    alt="Cafe cover"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "150px",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </Col>
          )}
          {hasValue(claim.logo) && (
            <Col lg={6}>
              <div className={styles[viewformStyle]} id={empdivId}>
                <span className={styles.title}>Logo</span>
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={claim.logo}
                    alt="Cafe logo"
                    style={{
                      maxWidth: "120px",
                      maxHeight: "120px",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </Col>
          )}
        </Row>
      )}
    </>
  );
}

export default ClaimSubmittedCafeProfile;
